import type { IconProps } from './types';
import './icons.css';

export default function LongArrowLeft({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 31}
      height={height || 15}
      viewBox="0 0 31 15"
      className={`icon icon-mastercard ${className || ''}`}
    >
      <path d="M31 7.5H1m0 0L7.5 1M1 7.5 7.5 14" stroke="currentColor" />
    </svg>
  );
}
